<template>
  <div class="message">
    <van-tabs v-model="active" title-active-color="#605C6B" color="#605C6B" @click="onClick" sticky>
      <van-tab :dot="cnoread" name="0">
        <div slot="title" style="display:inline-flex">
          评论 
        </div>
        <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已加载全部"
        @load="onLoad"
        >
        <div slot="loading" class="list-loading">
          <img :src="img.loading" />
        </div>
        <div v-for="item in list" :key="'list_' + item.comment_id">
          <van-swipe-cell>
            <van-cell center>
              <template slot="title">
                <div class="message-title">{{item.comment.user.user_name}} 评论我：</div>
                <van-row justify="space-between">
                  <van-col span="22">
                    <span class="ellipsis-2 f-12">
                      {{item.comment.content}}
                    </span>
                  </van-col>
                  <van-col span="2">
                    <van-tag v-if="item.is_read==0" type="danger" round></van-tag>
                  </van-col>
                </van-row>
                <div class="sourtime f-12">{{item.created_at}}</div>
              </template>
            </van-cell>
            <template slot="right">
              <van-button square type="danger" :data-name="0" :data-code="item.comment_id" @click="delMessage" text="删除" />
            </template>
          </van-swipe-cell>
        </div>
      </van-list>
    </van-tab>
    <van-tab :dot="snoread" name="2">
      <div slot="title" style="display:inline-flex">
        系统消息
      </div>
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已加载全部"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="img.loading" />
      </div>
      <div v-for="item in lists" :key="'slist_' + item.id">
        <van-swipe-cell>
          <van-cell-group>
            <van-cell center class="message-title" :title="item.title" :label="item.created_at">
              <template #extra>
                <div class="my_dot" v-if="item.is_read==0"></div>
              </template>
            </van-cell>
          </van-cell-group>
          
          
          <template slot="right">
            <van-button square type="danger" :data-name="1" :data-code="item.id" @click="delMessage" text="删除" />
          </template>
        </van-swipe-cell>
      </div>
    </van-list>
  </van-tab>
  <!-- <van-tab>
    <div slot="title" style="display:inline-flex">
      问答
    </div>
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="img.loading" />
    </div>
    <div v-for="item in lista" :key="'qlist_' + item.id">
      <van-swipe-cell>
        <van-cell-group>
          <van-cell class="message-title" title="您的提问收到一个新回答，快去看看吧" :label="item.created_at" />
        </van-cell-group>
        <template slot="right">
          <van-button square type="danger" :data-name="1" :data-code="item.id" @click="delMessage" text="删除" />
        </template>
      </van-swipe-cell>
    </div>
  </van-list>
</van-tab> -->
</van-tabs>
</div>
</template>
<script>
  import common from '../../../api/common';
  import list from '../../../api/member/mymessage';
  import { mapState } from 'vuex';
  import { Tab, Tabs, List, Row, Col, Tag, Grid, GridItem,Cell, CellGroup,SwipeCell,Button } from 'vant';
  export default {
    data(){
      return{
        active: 0,
        list:[],
        lista: [],
        lists:[],
        params:{
         page:1,
         size:10,
         media_id:6
       },
       user_id:'',
       loading: false,
       finished: false,
       cnoread:false,
       snoread:false,
       img: {
        loading: require('../../../assets/img/loading_lexus.gif'),
        parise: require('../../../assets/img/parise.png'),
        parise_have: require('../../../assets/img/parise_have.png'),
        comment: require('../../../assets/img/comment.png'),
        avatar: require('../../../assets/img/default.jpg'),
        question: require('../../../assets/img/question.png'),
        answer: require('../../../assets/img/answers.png'),
      }
    }

  },
  computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
    this.active = this.$route.query.active
     this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      } else {
        this.$appService.needLogin()
      }
    })
     var params={
      event_code: '我的消息',
      event_id: '',
      title: '',
      value: '',
      path: '/Lexus/My/MyMessage.vue',
      user_id: this.user ? this.user.id : 0,
      source: this.source
    }
    common.BurialPoint(params).then(res => {
      if(res.data.state==1){
      }
    })
    var apppar={
      title:this.$route.meta.title
    }
    this.$appService.changeTitle(apppar)
    this.getNoticeNum()
  },
  methods: {
    onClick(name){
      if(name==0){
        this.list=[]
        this.params.page=1
        this.finished=false
        this.getComments()
      }else if(name==1){
        this.lista=[]
        this.params.page=1
        this.finished=false
        this.getAnswer()
      }else if(name==2){
        this.lists=[]
        this.params.page=1
        this.finished=false
        this.getSystem()
        
      }
    },
    
    getNoticeNum(){
      list.getNoticenum().then(res => {
        var ask_nums = parseInt(res.data.data.ask_nums)
        var comment_nums = parseInt(res.data.data.comment_nums)
        var system_nums = parseInt(res.data.data.system_nums)
        var noticeNum = ask_nums + comment_nums + system_nums
        if (comment_nums > 0) {
          this.cnoread= true
        } else {
          this.cnoread= false
        }
        if (system_nums > 0) {
          this.snoread= true
        } else {
          this.snoread= false
        }
      })
    },
    delMessage(e){
      let id=e.currentTarget.dataset.code
      let name=e.currentTarget.dataset.name
      this.$dialog.confirm({
        message: '确定要删除吗？'
      }).then(() => {
        if(name==0){
          list.delMessage(id).then(res => {
            if(res.data.state == 1) {
              let list=this.list
              for (var i=0;i<list.length;i++) {
                if(list[i].comment_id==id){
                 list.splice(i, 1)
               }
             }
             this.list=list
             this.$toast.success('删除成功');
           }
         })
        }else{
         list.delMessage(id).then(res => {
          if(res.data.state == 1) {
            let alist=this.alist
            for (var i=0;i<alist.length;i++) {
              if(alist[i].id==id){
               alist.splice(i, 1)
             }
           }
           this.alist=alist
           this.$toast.success('删除成功');
         }
       })
       }
     }).catch(() => {
     });
   },
   getComments(){
    list.getComments(this.params).then(res => {
      this.list.push.apply(this.list, res.data.data.data)
      this.params.page += 1
      this.total = res.data.data.total
      this.loading = false
      if(res.data.data.data.length == 0) {
        this.finished = true
      }
    })
  },
  getSystem(){
    list.getSystem(this.params).then(res => {
      this.lists.push.apply(this.lists, res.data.data.data)
      this.params.page += 1
      this.total = res.data.data.total
      this.loading = false

      if(res.data.data.data.length == 0) {
        this.finished = true
      }
    })
  },
  getAnswer(){
    list.getAnswer(this.params).then(res => {
      this.lista.push.apply(this.lista, res.data.data.data)
      this.params.page += 1
      this.total = res.data.data.total
      this.loading = false

      if(res.data.data.data.length == 0) {
        this.finished = true
      }
    })
  },
  onLoad() {
    if(this.active==0){
      setTimeout(() => {
        this.getComments()
      }, 500);
    }else if(this.active==1){
      setTimeout(() => {
        this.getAnswer()
      }, 500);
    }else if(this.active==2){
      setTimeout(() => {
        this.getSystem()
      }, 500);
    }
  },
},
components: {
  [Row.name]: Row,
  [Col.name]: Col,
  [Grid.name]: Grid,
  [GridItem.name]: GridItem,
  [List.name]: List,
  [Tabs.name]: Tabs,
  [Tab.name]: Tab,
  [Tag.name]: Tag,
  [Cell.name]: Cell,
  [CellGroup.name]: CellGroup,
  [SwipeCell.name]:SwipeCell,
  [Button.name]:Button
}
}
</script>

<style lang="scss">
.message{
  .message-title{
    font-size: 12px;
    color: #605C6B;
  }
  .ellipsis-2{
    color: #6A6A6A;
  }
  .listhand{
    padding: 15px;
    border-bottom: 1px solid #eaeaea;
    color: #9A9A9A;
  }
  .van-cell__label{
    color: #9A9A9A;
  }
  .van-cell{
    border-bottom:1px solid #eaeaea;
  }
  .van-tag{
    padding: 2px;
    float: right;
    margin-top: 80%;
  }
  .sourtime{
    color: #9A9A9A;
  }
  .van-button--square {
    height: 100%;
  }
  .my_dot{
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #E10000;
  }
}


</style>
